var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatures(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "269px",
    height: "271px",
    viewBox: "0 0 269 271",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "18.8314766%",
    cy: "50%",
    fx: "18.8314766%",
    fy: "50%",
    r: "129.320036%",
    gradientTransform: "translate(0.188315,0.500000),scale(1.000000,0.500000),rotate(90.000000),translate(-0.188315,-0.500000)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6758FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7FA7",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "StaFihub",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V2-Copy",
    transform: "translate(-89.000000, -975.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(89.000000, 975.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-29",
    fill: "#6758FF",
    cx: 134.5,
    cy: 135.5,
    r: 134.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,1.27693817 C128.213829,1.04028154 130.57962,0.921953231 133.097373,0.921953231 C135.615126,0.921953231 137.916001,0.988353078 140,1.12115277 L139.972644,269.913003 C137.722472,269.999767 135.430715,270.032703 133.097373,270.01181 C130.76403,269.990918 128.39824,269.916278 126,269.787893 L126,1.27693817 Z",
    id: "Rectangle-37",
    fill: "#000002"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-30",
    fill: "#000002",
    cx: 201.5,
    cy: 133.5,
    r: 43.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,91 C106.300529,91 126,110.699471 126,135 C126,159.300529 106.300529,179 82,179 L82,179 Z",
    id: "Combined-Shape",
    fill: "url(#radialGradient-1)",
    transform: "translate(104.000000, 135.000000) rotate(-180.000000) translate(-104.000000, -135.000000) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-31",
    fill: "#000002",
    cx: 49,
    cy: 135,
    r: 20
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures);
export default __webpack_public_path__ + "static/media/features.0b3def2b22e76aa27b59ce24194722ca.svg";
export { ForwardRef as ReactComponent };